export default {
  API_URL: "https://www.location-ski-villard-reculas.com",
  APP_PATH: "/reservez-vos-skis-en-ligne",
  JWT_TOKEN: "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpYXQiOjE2MDI3MDU0OTUsImV4cCI6MTYwMzU2OTQ5NSwidXNlcm5hbWUiOiJuaWNvbGFzIn0.GdtlC5QIFE1SnNa0SlHLAkWQV6EecVsjudeds9O7Hr2G4JwRWNM7L6IYux15IpzxOjA4g7_HX5qqArkc1uNKsaaisvwKfrfhpZYpsmLdnzC0zGFW6Dw0MyndmiefONnP2MD0yiExs7R3272kEpEJf2p_hupIdbPg3WP1s170KRPG1S1V0yLEz7H4ey-VkVY9yipMJJ4lVSee3V83bMb3S676pi85kD3OFRvFu4AnVw94wtaI_fODTS_DGe5UuSSdhDMEBHMfwhM6gTa3kxscmQkZC_YLTv_1wzxAEnbVpbvZZLuE7-IXQw5gK4jYbKgrFVNov55wqtaEKOb3MMxh60W_mpERW4YiRhuUW8rBj_BFB2whb8lE_5qrJ2uZ0LwLPrNFMEFr2DtWGlfIjdQk1rMMBicUNWRV6n_l7k7b8Z8yMNhbkv6055cj2C0ouQrj6khz95ssDOPm0fzBF-REp31sGH0XhZRV-F_z6UDbJaTHNA_Ibq3MoGCnTOuRDPbaW2H68PgRkY5ionTYYhJnw6UPz4-qfMjk1wJ21IA9nedh5vlX2crZdEdMx6vyHrEX_p_kf_lG5V-9mMH19aai4X1cr407Kmt1VEG1HyZcfw4h2DVGwEAgpT3tudTvD9XfYxH78CCHcQlXsUgsU2HoSbieLuOcOixofBgV9Qnuyi8",
  MAX_DAYS: 14,
  SHOP_ADDRESS: 'Route des Pistes',
  SHOP_CITY: 'Villard Reculas',
  SHOP_EMAIL: 'contact@ptitpingouin.com',
  SHOP_NAME: 'Ptit Pingouin',
  SHOP_PHONE: '04 76 80 45 58',
  SHOP_ZIPCODE: '38114',
  TVA_RATE: 0.2
}
